import PropTypes from 'prop-types'
import { image } from '@proptypes'
import { NewBadge } from '#src/common/components/badge'
import { ProductImageWrapper, ImageBadges } from './styles'
import { getImage } from '#src/common/components/image/get-image'

const ProductImage = ({ image, newUntil, placeholder }) => {
  const isNew = date => {
    const now = new Date().getTime()
    const expires = new Date(date).getTime()
    return expires > now
  }

  return (
    <ProductImageWrapper data-testid='product-image'>
      {getImage({
        img: image ?? placeholder,
        ariaHidden: true
      })}
      {isNew(newUntil) && (
        <ImageBadges>
          <NewBadge key='new' />
        </ImageBadges>
      )}
    </ProductImageWrapper>
  )
}

ProductImage.propTypes = {
  placeholder: image.isRequired,
  name: PropTypes.string.isRequired,
  image,
  newUntil: PropTypes.string
}

ProductImage.defaultProps = {
  image: undefined,
  newUntil: undefined
}

export default ProductImage
